webpackJsonp([35783957827783],{

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.styles = undefined;
	
	var _border = __webpack_require__(662);
	
	var _border2 = _interopRequireDefault(_border);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  container: {
	    height: '100vh',
	    minHeight: 450,
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'space-around',
	    '@media (max-width: 767px)': {
	      height: 'unset'
	    }
	  },
	  mainContent: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center',
	    '& p': {
	      fontSize: 24,
	      fontFamily: 'TTNorms-Regular',
	      lineHeight: '36px',
	      marginBottom: 43
	    },
	    '& strong': {
	      fontFamily: 'TTNorms-Bold'
	    },
	    '& > img': {
	      marginTop: 60,
	      marginLeft: -11,
	      width: 75
	    },
	    '@media (max-width: 767px)': {
	      marginTop: 60,
	      marginBottom: 20
	    }
	  },
	  button: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    width: 190,
	    height: 34,
	    padding: '2px 0 2px 0',
	    marginRight: 20,
	    marginBottom: 20,
	    border: '2px solid #1F1F1F',
	    borderRadius: 4,
	    textDecoration: 'none',
	    textAlign: 'center',
	    color: '#1F1F1F',
	    fontSize: 16,
	    '&:hover': {
	      backgroundColor: '#1F1F1F',
	      color: 'white'
	    }
	  },
	  link: {
	    display: 'inline-block',
	    padding: '2px 0 2px 0',
	    color: '#1F1F1F',
	    fontSize: 16
	  },
	  notes: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    marginTop: 40,
	    marginBottom: 10,
	    '& > a': {
	      marginRight: 20
	    }
	  },
	  borderTop: {
	    display: 'inline-block',
	    borderTop: '1px solid rgba(0,0,0,.3)',
	    paddingTop: 7
	  },
	  linkParagraph: {
	    width: 190,
	    textDecoration: 'none',
	    color: '#1F1F1F',
	    fontSize: 12,
	    lineHeight: '15px',
	    '& strong': {
	      fontFamily: 'TTNorms-Bold',
	      '&:before': {
	        content: '" "',
	        display: 'inline-block',
	        width: 8,
	        height: 8,
	        borderRadius: '100%',
	        marginRight: 4,
	        backgroundColor: '#1F1F1F'
	      }
	    }
	  },
	  available: {
	    '& strong': {
	      color: '#2AB053',
	      '&:before': {
	        backgroundColor: '#2AB053'
	      }
	    }
	  },
	  unavailable: {
	    '& strong': {
	      color: '#EF6060',
	      '&:before': {
	        backgroundColor: '#EF6060'
	      }
	    }
	  },
	  socialMedias: {
	    width: 190,
	    color: '#1F1F1F',
	    fontSize: 12,
	    lineHeight: '15px',
	    '& > p': {
	      marginBottom: 8
	    },
	    '& a': {
	      display: 'inline-block',
	      fontSize: 18,
	      color: '#1F1F1F',
	      textDecoration: 'none',
	      margin: '0 16px 0 0',
	      '&:last-child': {
	        marginRight: 0
	      },
	      '& > .icn-medium:hover': {
	        color: '#02B875'
	      },
	      '& > .icn-dribbble:hover': {
	        color: '#EC4A89'
	      },
	      '& > .icn-linkedin:hover': {
	        color: '#0077B5'
	      }
	    }
	  },
	  canvas: {
	    height: '100vh',
	    padding: 0,
	    backgroundColor: '#F2F2F2',
	    border: 0,
	    borderLeft: '4px solid transparent',
	    borderImage: 'url(' + _border2.default + ') 0% 10 repeat'
	  },
	  paddingRight0: {
	    paddingRight: 0
	  },
	  marginLeftNeg90: {
	    marginLeft: -90
	  }
	};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/JDeveaux-logo.05c299b7.svg";

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactJss = __webpack_require__(10);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _JDeveauxLogo = __webpack_require__(95);
	
	var _JDeveauxLogo2 = _interopRequireDefault(_JDeveauxLogo);
	
	var _Loader = __webpack_require__(23);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _index = __webpack_require__(258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isLoaded: false
	    };
	    return _this;
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ isLoaded: true });
	  };
	
	  IndexPage.prototype.render = function render() {
	    var classes = this.props.classes;
	    var isLoaded = this.state.isLoaded;
	
	    return isLoaded ? _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('row', classes.paddingRight0) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col-sm-6 col-xs-10 col-xs-offset-1', classes.container) },
	        _react2.default.createElement(
	          'div',
	          { className: classes.mainContent },
	          _react2.default.createElement('img', { src: _JDeveauxLogo2.default, className: 'hideMDDown' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Julien Deveaux'
	            ),
	            ', Entrepreneur, Product Designer, Teacher and Mentor crafting products with tech companies in Europe, Silicon Valley, New York and Latin America.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: '/contact',
	                className: classes.button },
	              'Get in touch'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: '/work',
	                className: classes.link },
	              'View past projects'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.notes },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/contact',
	              className: (0, _classnames2.default)(classes.borderTop, classes.linkParagraph, classes.available) },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Available'
	              ),
	              ' for some freelance work, send me a note and we will start from there.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(classes.borderTop, classes.socialMedias) },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Find out more on social medias:'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://medium.com/@juliendeveaux' },
	              _react2.default.createElement('i', { className: 'icn-medium' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://dribbble.com/JulienDeveaux' },
	              _react2.default.createElement('i', { className: 'icn-dribbble' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.linkedin.com/in/juliendeveaux/' },
	              _react2.default.createElement('i', { className: 'icn-linkedin' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('canvas', { className: (0, _classnames2.default)('col-xs-4 col-xs-offset-1 hideMDDown', classes.canvas) })
	    ) : _react2.default.createElement(
	      'div',
	      { style: {
	          display: 'flex',
	          alignItems: 'center',
	          justifyContent: 'center',
	          height: '100vh'
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'containerAdjustMobile', style: {
	            position: 'relative'
	          } },
	        _react2.default.createElement('div', { style: {
	            width: 120,
	            height: 120,
	            display: 'flex',
	            alignItems: 'center',
	            justifyContent: 'center',
	            border: '2px solid #f3f3f3',
	            borderTop: '3px solid #000',
	            borderRadius: '100%',
	            animationName: 'spin',
	            animationDuration: '1s',
	            animationTimingFunction: 'linear',
	            animationIterationCount: 'infinite'
	          } }),
	        _react2.default.createElement('img', {
	          src: _Loader2.default,
	          alt: 'laoding',
	          style: {
	            width: 60,
	            position: 'absolute',
	            top: 0,
	            bottom: 0,
	            right: 0,
	            left: 0,
	            margin: 'auto'
	          } })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactJss2.default)(_index.styles)(IndexPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c2050df660f2c24735f0.js